// Diğer: etiket ve yazar kasa için seyrek gereken alanlar.
import React from 'react';
import { Autocomplete, Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COUNTRIES, TURKEY_CODE, countryCodeToFlag } from '../../../../../utils/countries';
import type { StockCardForm } from '../useStockCardForm';
import { SectionTitle } from './fields';

export const OtherSection: React.FC<{ f: StockCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');

  return (
    <Box>
      <SectionTitle
        title={t('stock.addModal.layout.sections.other', 'Diğer')}
        hint={t('stock.addModal.layout.otherHint', 'Etikete basılan menşei bilgisi ve yazar kasa departmanı.')}
      />
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 2fr) minmax(0, 1fr)' }, gap: 1.5, alignItems: 'center' }}>
        <Autocomplete
          fullWidth
          size="small"
          id="stock-card-origin"
          options={COUNTRIES}
          getOptionLabel={(option) => `${countryCodeToFlag(option.code)}  ${option.name}`}
          value={COUNTRIES.find((c) => c.code === f.countryOfOrigin) ?? null}
          onChange={(_, value) => f.setCountryOfOrigin(value?.code ?? '')}
          isOptionEqualToValue={(option, value) => option.code === value.code}
          renderInput={(params) => (
            <TextField {...params} size="small" label={t('stock.addModal.layout.origin', 'Menşei (üretim yeri)')} />
          )}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={f.isDomesticProduct}
              onChange={(e) => {
                f.setIsDomesticProduct(e.target.checked);
                // Menşei boşsa Türkiye varsayılır; dolu seçime dokunulmaz.
                if (e.target.checked && !f.countryOfOrigin) f.setCountryOfOrigin(TURKEY_CODE);
              }}
            />
          )}
          label={t('stock.addModal.layout.domestic', 'Yerli malı')}
        />
      </Box>

      <TextField
        id="stock-card-department"
        size="small"
        type="number"
        sx={{ mt: 1.5, width: { xs: '100%', sm: 260 } }}
        label={t('stock.addModal.fields.departmentNo')}
        value={f.departmentNo}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '' || (Number(value) >= 1 && Number(value) <= 10)) {
            f.setDepartmentNo(value === '' ? '' : Number(value));
          }
        }}
        inputProps={{ min: 1, max: 10, step: 1 }}
        helperText={`${t('stock.addModal.fields.departmentNoHint')} ${t('stock.addModal.fields.departmentNoInfo')}`}
      />
    </Box>
  );
};
